export const SET_ADMIN_USERROLE = 'ADMIN/SET_ADMINROLE'
export const setIsAdmin = (isAdmin: boolean) => ({
  type: SET_ADMIN_USERROLE,
  isAdmin
})

export const SET_BACKOFFICE_USERROLE = 'ADMIN/SET_BACKOFFICEROLE'
export const setIsBackOffice = (isBackOffice: boolean) => ({
  type: SET_BACKOFFICE_USERROLE,
  isBackOffice
})

export const SET_ROOT_CONTRIBUTOR_USERROLE = 'ADMIN/SET_ROOTCONTRIBUTORROLE'
export const setIsRootContributor = (isRootContributor: boolean) => ({
  type: SET_ROOT_CONTRIBUTOR_USERROLE,
  isRootContributor
})
